import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledSubTitle = styled.div`
    display: flex;
    ${mixins.setFontVariant("chip1", colorsPalettes.carbon[400])};
`;
